import React from 'react';

import { Link } from '@vtblife/uikit';

import { useConfigContext } from '../../shell/contexts';
import styles from './bottom.module.css';

export const Bottom = () => {
    const { ITRequirements, copyright } = useConfigContext();

    const markdownRegExp = /(.+?) \[(.*?)\]\((.*?)\)/;
    const match = ITRequirements && ITRequirements.match(markdownRegExp);

    return (
        <div>
            {match && (
                <div className={styles.requirements}>
                    {match[1]}{' '}
                    <Link href={match[3]} target="blank">
                        <span className={styles.requirementsLink}>{match[2]}</span>
                    </Link>
                </div>
            )}
            <div className={styles.copyright}>{copyright}</div>
        </div>
    );
};
